import React from 'react';
import { IonAlert } from '@ionic/react';

const NotificationPermissionModal = ({ isOpen, header, message, onAllow, onCancel, onDeny }) => {
  return (
    <IonAlert
      isOpen={isOpen}
      header={header}
      message={message}
      buttons={[
        { text: 'Not now', role: 'cancel', handler: onDeny || onCancel },
        { text: 'Allow', handler: onAllow },
      ]}
      onDidDismiss={onCancel}
    />
  );
};

export default NotificationPermissionModal;

